module.exports = __webpack_public_path__ + "img/img-3.6c5c3c31.webp";